"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migrationConfig = void 0;
exports.migrationConfig = {
    shouldRedirectToSupplyMigration: true,
};
